export interface SpecialBannerProps {
    location?: string
}

export enum XMAS_BANNER_LOCATION {
    catalog,
    articleDetail,
    mylounge
}